import { ParametrosWSBase, DestinoConexion } from "../ParametrosWSBase";
import { EncabezadoRespuestaInterna } from "../EncabezadoRespuestaInterna";

export function ReenviarCorreo_Parametros(datos: any) {
  var par: ParametrosWSBase = {
    nombreProceso: "ReeSendEmailConfirmation",
    rutaEndPoint: "/EnterpriseServices/Sel/ReEnviarEmailPreRegSelEBSRest",
    sistemaOrigen: "AppSky",
    AGREGAR_ENCABEZADO: true,
    DESTINO_SERVICIO: DestinoConexion.Proxy,
    parametros: { ...datos },
        cRC:null
  };

  return par;
}

export function builtReenviarCorreoInput(
  l_Email: string,
  l_Servicio: string, 

) {
  var retorno: ReenviarCorreo_Entrada =
    builtReenviarCorreo_Entrada(
      builtReEnviarEmailPreRegSelInputMessage(l_Email,l_Servicio)
    );

  return retorno;
}

//ENTRADA
export interface ReenviarCorreo_Entrada {
  ReEnviarEmailPreRegSelInputMessage: ReEnviarEmailPreRegSelInputMessage;
}

export function builtReenviarCorreo_Entrada(
  l_ReEnviarEmailPreRegSelInputMessage: ReEnviarEmailPreRegSelInputMessage
) {
  var retorno: ReenviarCorreo_Entrada = {
    ReEnviarEmailPreRegSelInputMessage:
      l_ReEnviarEmailPreRegSelInputMessage,
  };

  return retorno;
}

export interface ReEnviarEmailPreRegSelInputMessage {
  Email: string;
  Servicio: string;

}

export function builtReEnviarEmailPreRegSelInputMessage(
  l_Email: string,
  l_Servicio: string,
  
  
) {
  var retorno: ReEnviarEmailPreRegSelInputMessage = {
    Email: l_Email,
    Servicio: l_Servicio,
  

  };

  return retorno;
}



export type ReenviarCorreo_Respuesta = EncabezadoRespuestaInterna ;